// extracted by mini-css-extract-plugin
export var container = "bK_b";
export var email = "bK_hF";
export var emails = "bK_hD";
export var location = "bK_cZ";
export var number = "bK_cp";
export var numbers = "bK_cn";